import { WEBSITE } from '../../lib/edition.js';

/**
 * Where the social and co-op routes live: on the website itself, or behind the
 * desktop server's pass-through to the website (`/api/website/...`), which
 * signs the request with the app's Prism account.
 */
export const social = (path: string): string => (WEBSITE ? path : `/website${path}`);
